import store from '@/states/index.js'

import SupplierDirectory from '../SupplierDirectory.vue'

export default [
    {
        path: '/supplierdirectory',
        component: SupplierDirectory,
        name: 'supplierdirectory',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 3){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]